// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fa-icon[data-v-5efa8ce4]{pointer-events:none;height:1em;line-height:0;display:inline-block}`, "",{"version":3,"sources":["webpack://./client/components/Icon.vue"],"names":[],"mappings":"AAGA,0BACE,mBAAA,CACA,UAAA,CACA,aAAA,CACA,oBAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
